import React, { useEffect, useState } from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

import { FaSnapchat, FaBasketballBall, FaGooglePlusG } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer1 = () => {
  const [footerColor, setFooterColor] = useState("#000");
  const [footerTextColor, setFooterTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [socialLinks, setSocialLinks] = useState({});
  const accessToken = sessionStorage.getItem("accessToken");
  const appName = sessionStorage.getItem("appName");
  const [categories, setCategories] = useState([]);


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setFooterColor(parsedStyle.footer_color);
      setFooterTextColor(parsedStyle.footer_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setSocialLinks({
        facebook: parsedStyle.facebook_link || "https://facebook.com",
        twitter: parsedStyle.twitter_link || "https://twitter.com",
        instagram: parsedStyle.instagram_link || "https://instagram.com",
        pinterest: parsedStyle.pinterest_link || "https://pinterest.com",
        linkedin: parsedStyle.linkedin_link || "https://linkedin.com",
        youtube: parsedStyle.youtube_link || "https://youtube.com",
        whatsapp: parsedStyle.whatsapp_link || "https://web.whatsapp.com/",
        appleStore:
          parsedStyle.apple_store_link ||
          "https://apps.apple.com/in/app/apple-store/id375380948?mt=8&mnid=sfo291LJq-dc_mtid_187079nc38483_pcrid_731945015408_pgrid_109516736059_pntwk_g_pchan__pexid_195442770243_ptid_kwd-12522920_&cid=aos-IN-kwgo-brand--slid-FER4pAmp--product-&mtid=187079nc38483&aosid=p238",
        playStore:
          parsedStyle.play_store_link ||
          "https://play.google.com/store/games?hl=en&pli=1",
        snapchat: parsedStyle.snapchat_link,
        dribble: parsedStyle.dribble_link,
        googlePLus: parsedStyle.google_plus_link,
      });
    }

    // Fetch categories
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/get_main_category_list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              admin_auto_id: sessionStorage.getItem("admin_auto_id"),
              app_type_id: sessionStorage.getItem("app_type_id"),
            }),
          }
        );
        const data = await response.json();
        if (data.status === 1) {
          // Take only the first 3 categories
          setCategories(data.getmain_categorylist.slice(0, 3));
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);



  return (
    <div
      className={`p-4 ${font}`}
      style={{ backgroundColor: footerColor, color: footerTextColor }}
    >
      <div className="container grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <div className="mt-5">
          <span className="font-bold " style={{ color: footerTextColor }}>
            Get Support
          </span>
          <div className="grid mt-3 text-sm leading-8">
            <Link className="text-decoration-none text-inherit" to="/aboutus">
              About Us
            </Link>
            <Link
              className="text-decoration-none text-inherit"
              to="/privacyandpolicy"
            >
              Privacy Policy
            </Link>
            {accessToken && (
              <Link
                className="text-decoration-none text-inherit"
                to={{
                  pathname: "/dashboard",
                }}
                state={{ page: "myorders" }}
              >
                Check order status
              </Link>
            )}
            <Link className="text-decoration-none text-inherit" to="/contact">
              Contact Us
            </Link>
            <Link
              className="text-decoration-none text-inherit"
              to="/termsandcondition"
            >
              Terms and Conditions
            </Link>
            <Link className="text-decoration-none text-inherit" to="/faq">
              FAQ
            </Link>
          </div>
        </div>

        {categories
          .filter(
            (category) =>
              category?.getmain_subcategorylist &&
              category.getmain_subcategorylist.length > 0
          )
          .map((category, index) => (
            <div key={index} className="mt-5">
              <span className="font-bold" style={{ color: footerTextColor }} >
                <Link to={`/maincategory/${category.category_auto_id}`} className="no-underline text-inherit">
                  {category.category_name}
                </Link>

              </span>
              <div className="grid mt-3 text-sm leading-8">
                {category.getmain_subcategorylist
                  .slice(0, 5)
                  .map((subcategory, subIndex) => (
                    <Link
                      key={subIndex}
                      className="text-decoration-none text-inherit"
                      to="/productlist"
                      state={{
                        subcategoryName: subcategory.sub_category_name,
                        sub_cat_id: subcategory.sub_category_auto_id,
                      }}
                    >
                      {subcategory.sub_category_name}
                    </Link>
                  ))}
              </div>
            </div>
          ))}

        <div className="mt-5">
          <span className="font-bold " style={{ color: footerTextColor }}>
            Get to know us
          </span>
          <div className="grid mt-3 text-sm leading-8">
            <Link className="text-decoration-none text-inherit" to="/aboutus">
              About {appName}
            </Link>
          </div>
        </div>
      </div>

      {/* <div className="container flex flex-wrap gap-2 mt-5">
        {[
          "https://s.alicdn.com/@img/imgextra/i1/O1CN01L00bAM1TmF3L42KkI_!!6000000002424-2-tps-286-80.png",
          "https://s.alicdn.com/@img/imgextra/i4/O1CN013pymTh1OIrZGMQ6iO_!!6000000001683-2-tps-93-80.png",
          "https://s.alicdn.com/@img/imgextra/i3/O1CN01CoqZOX1E5uCoNiJIr_!!6000000000301-2-tps-75-80.png",
          "https://s.alicdn.com/@img/imgextra/i3/O1CN01xBSIuv1ReKzDOHrTb_!!6000000002136-2-tps-214-80.png",
          "https://s.alicdn.com/@img/imgextra/i1/O1CN01ba6iSo1PHJqZo1Gba_!!6000000001815-2-tps-81-80.png",
          "https://s.alicdn.com/@img/imgextra/i4/O1CN01dsw9V61Lbh0D1f9JG_!!6000000001318-2-tps-205-112.png",
          "https://s.alicdn.com/@img/imgextra/i4/O1CN01sXbha020agNJcLC4l_!!6000000006866-2-tps-148-112.png",
          "https://s.alicdn.com/@img/imgextra/i1/O1CN017IIzE71MpGLv2nxMd_!!6000000001483-2-tps-260-112.png",
          "https://s.alicdn.com/@img/imgextra/i1/O1CN01pwSjDv25t4M1W8Xu8_!!6000000007583-2-tps-165-112.png",
          "https://s.alicdn.com/@img/imgextra/i1/O1CN017IIzE71MpGLv2nxMd_!!6000000001483-2-tps-260-112.png",
          "https://s.alicdn.com/@img/imgextra/i3/O1CN01Wv6lOf1OTOfx5Dppk_!!6000000001706-2-tps-171-112.png",
          "https://s.alicdn.com/@img/imgextra/i1/O1CN01EF6Zjm21spgURRwKI_!!6000000007041-2-tps-138-112.png",
        ].map((src, index) => (
          <img
            key={index}
            className="h-8"
            src={src}
            alt=""
            style={{ backgroundColor: themeColor }}
          />
        ))}
      </div> */}

      <div className="container flex flex-wrap gap-4 p-3 mt-2">
        <div className="flex space-x-4">
          {[
            { Icon: FaFacebookSquare, link: socialLinks.facebook },
            { Icon: FaLinkedinIn, link: socialLinks.linkedin },
            { Icon: FaTwitter, link: socialLinks.twitter },
            { Icon: FaInstagram, link: socialLinks.instagram },
            { Icon: FaYoutube, link: socialLinks.youtube },
            { Icon: FaWhatsapp, link: socialLinks.whatsapp },
            { Icon: FaBasketballBall, link: socialLinks.dribble },
            { Icon: FaSnapchat, link: socialLinks.snapchat },
            { Icon: FaGooglePlusG, link: socialLinks.googlePLus },
          ]
            .filter((item) => item?.link && item.link.trim() !== "")
            .map(({ Icon, link }, index) => (
              <a
                key={index}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 text-decoration-none"
              >
                <Icon
                  style={{ color: themeIconColor, opacity: 1, fontSize: "24px" }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.7)}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = 1)}
                />
              </a>
            ))}
        </div>

        <div className="flex flex-col ml-16 sm: md:flex-row">
          <p className="mt-4">
            Trade on the go with the{" "}
            <Link className="font-bold text-inherit " to="/">
              {appName} app
            </Link>{" "}
          </p>
          <a
            href={socialLinks.appleStore}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="h-10 m-2 "
              src="https://s.alicdn.com/@img/imgextra/i4/O1CN01i9Aj641atkjJJ9I6y_!!6000000003388-2-tps-396-132.png"
              alt=""
            />
          </a>

          <a
            href={socialLinks.playStore}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="h-10 m-2"
              src="https://s.alicdn.com/@img/imgextra/i4/O1CN018KnDNq1JleFgkjLRq_!!6000000001069-2-tps-447-132.png"
              alt=""
            />
          </a>
        </div>
      </div>

      <div
        className="p-2 text-center "
        style={{ backgroundColor: themeColor, color: footerTextColor }}
      >
        {/* <p>
          AliExpress | 1688.com | Tmall Taobao World | Alipay | Lazada | Taobao
          Global | TAO
        </p> */}
        {/* <p>
          Policies and rules | Legal Notice | Product Listing Policy | Privacy
          Policy | Terms of Use
        </p> */}
        <p>
          Policies and rules | Privacy
          Policy | Terms of Use
        </p>
        <p>
          © {new Date().getFullYear()} {appName} All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer1;
